import { get, post } from '../index';

export async function getPreforms(projectId) {
    let preformsResponse = await get(`projects/${projectId}/preforms`, {});
    return preformsResponse ? preformsResponse.preEnergizations : [];
}

export async function getPreform(projectId, formId) {
    let preformsResponse = await get(`projects/${projectId}/preformview/${formId}`, {});
    return preformsResponse ? preformsResponse.preEnergizationForm : [];
}

export async function getOutageRecord(reqNo) {
    let outageRecord = await get(`projects/outagedata/${reqNo}`, {});
    return outageRecord;
}

export async function getPreformEdit(projectId, formId) {
    let preformsResponse = await get(`projects/${projectId}/preformedit/${formId}`, {});
    return preformsResponse ? preformsResponse.preEnergizationForm : [];
}

export async function getPreFormComments(projectId, formId) {
    let response = await get(`projects/${projectId}/preforms/${formId}/comments`);
    return response ? response.preFormComments : [];
}

export function addnewPreFormComment(comments, projectId, formId) {
    return post(`projects/${projectId}/preforms/${formId}/newComments`, {}, {comments});
}

export async function getTasksForForm(projectId, formId) {
    let qs = {isDesktop: 'Y'};
    let preformsResponse = await get(`projects/${projectId}/preforms/${formId}/tasks`, qs);
    return preformsResponse ? preformsResponse.tasks : [];
}

export async function getIpsLocationsForForm(projectId, formId) {
    let preformsResponse = await get(`projects/${projectId}/preforms/${formId}/ipsLocations`, {});
    return preformsResponse ? preformsResponse.ipsLocations : [];
}

export async function deletePreform(formId) {
    let preformsResponse = await get(`projects/preforms/${formId}/delete`, {});
    return preformsResponse ? preformsResponse.preEnergizations : [];
}

export async function getNewPreform(projectId) {
    let preformsResponse = await get(`projects/${projectId}/preforms/new`, {});
    return preformsResponse.preEnergizationForm;
}

export function createPreform(request, projectId) {
    return post(`projects/${projectId}/preforms/create`, {}, request);
}

export function updatePreform(request, projectId, formId) {
    return post(`projects/${projectId}/preforms/${formId}/update`, {}, request);
}

export function undoPreEFormEnergization(request, projectId, formId) {
    return post(`projects/${projectId}/preforms/${formId}/unenergized`, {}, request);
}

export function energizationPreEForm(request, projectId, formId) {
    return post(`projects/${projectId}/preforms/${formId}/energized`, {}, request);
}

export async function getNewPreEFormException(formId) {
    let response = await get(`projects/preforms/${formId}/exception/new`, {});
    return response.preEnergizationFormException;
}

export async function getPreEFormException(exceptionId) {
    let response = await get(`projects/preforms/exception/${exceptionId}`, {});
    return response.preEnergizationFormException;
}

export function updatePreEFormException(request) {
    let response = post(`projects/preforms/exception/update`, {}, request);
    return response;
}

export async function getExceptionAttachments(exceptionId) {
    let response = await get(`exceptionAttachments/${exceptionId}`);
    return response ? response.preExceptionAttachmentsList : {};
}

export function restartApprovalProcess(approvalId) {
    let response = post(`approvals/restart/${approvalId}`, {}, {});
    return response;
}

export function updateApprovStatusLog(request) {
    let response = post(`projects/preforms/exception/approverstatus/update`, {}, request);
    return response;
}

export function requestApprover(request) {
    let response = post(`projects/preforms/exception/request/approver`, {}, request);
    return response;
}

export function cancelApprover(request) {
    let response = post(`projects/preforms/exception/cancel/approver`, {}, request);
    return response;
}

export function approverProcess(request) {
    let response = post(`projects/preforms/exception/approve/approver`, {}, request);
    return response;
}

export async function getPreEFormExceptions(preFormId) {
    let response = await get(`projects/preforms/${preFormId}/exceptions`, {});
    return response.preEnergizationFormExceptions;
}

export function deletePreformException(request) {
    let response = post(`projects/preforms/exception/delete`, {}, request);
    return response;
}

export async function missedApproverRoles(exceptionId) {
    let response = await get(`projects/exception/${exceptionId}/missedapprovers`);
    return response ? response.roles : [];
}

export async function getApprovalsPage(formId, exceptionId) {
    let response = await get(`projects/preforms/${formId}/exceptions/${exceptionId}/approvals`);
    return response;
}

export async function getPreEngPdfReport(projectId, formId, requestDate) {
    let response = await get(`pdfReport/${projectId}/${formId}/${requestDate}`);
    return response;
}
